/*
    Copyright (C) 2023 - Wheel and Brake - Southwest Airlines
*/
import React from "react";
import plane from "../../assets/Southwest_Plane.jpeg";

function HomePage() {
    return (
        <div>
            <div style={{display: "flex", justifyContent: "center", verticalAlign: "center", alignItems: "center", height: "20vh"}}>
                <h1>Welcome to Wheel and Brake</h1>
            </div>
            <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "328px"}}>
                <img src={plane} alt="Southwest plane flying"/>
            </div>
        </div>
    );
}

export default HomePage;